import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'Payload to be executed',
  description: 'After passing of the proposal the following payload will be executed;',

  buttonTitle: 'Ok, I got it',
});
